export async function sha256Async(data: string): Promise<Uint8Array> {
    const msgBuffer = new TextEncoder().encode(data);                    
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    return new Uint8Array(hashBuffer);
}